import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import RepAsistencia from "./RepAsistencia";
import EstudiantesList from "../Academicos/EstudiantesList";
import RepNotasCert from "./RepNotasCert";
import RepConstancia from "./RepConstancia";
import RepSolicitudes from "./RepSolicitudes";
import ListUsuarios from "./ListUsuarios";
import RepEstRetirados from './RepEstRetirados';

class MainReportes extends Component {
    state = {
        valorReporte: { value: 'asistencia', label: 'Listado de Asistencia' },
    }

    Selecciona = (link) => {
        switch (link) {
            case "/reportes/asistencia": return({ value: 'asistencia', label: 'Listado de Asistencia' })
            case "/reportes/list_estudiantes": return({ value: 'list_estudiantes', label: 'Listado de Estudiantes' })
            case "/reportes/notas_certificadas": return({ value: 'notas_certificadas', label: 'Notas Certificadas' })
            case "/reportes/constancia_estudios": return({ value: 'constancia_estudios', label: 'Constancia de Estudios (Simple)' })
            case "/reportes/list_usuarios": return({ value: 'list_usuarios', label: 'Listado de Usuarios' })
            case "/reportes/carta_egreso": return({ value: 'carta_egreso', label: 'Carta de Egreso' })
            case "/reportes/carga_horaria": return({ value: 'carga_horaria', label: 'Carga Horaria' })
            case "/reportes/pensum_programas": return({ value: 'pensum_programas', label: 'Certificación Plan de Estudios (Pensum)' })
            case "/reportes/mod_estudios_simple": return({ value: 'mod_estudios_simple', label: 'Constancia de Modalidad de Estudio (Simple)' })
            case "/reportes/mod_estudios_cert": return({ value: 'mod_estudios_cert', label: 'Constancia de Modalidad de Estudio (Certificada)' })
            case "/reportes/culminacion_est_dir": return({ value: 'culminacion_est_dir', label: 'Constancia de Culminación de Estudios (Simple)' })
            case "/reportes/culminacion_est_cert_dir": return({ value: 'culminacion_est_dir', label: 'Constancia de Culminación de Estudios (Certificada)' })
            case "/reportes/constancia_conducta_cert_dir": return({ value: 'constancia_conducta_cert_dir', label: 'Constancia de Buena Conducta (Certificada)' })
            case "/reportes/est_retirados": return({ value: 'est_retirados', label: 'Estudiantes Retirados' })
            default: return({ value: 'asistencia', label: 'Listado de Asistencia' })
        }
    }

    valorReporteLabel = (link) => {
        switch (link) {
            case "/reportes/asistencia": return('Asistencia')
            case "/reportes/list_estudiantes": return('Listado de Estudiantes')
            case "/reportes/notas_certificadas": return('Notas Certificadas')
            case "/reportes/constancia_estudios": return('Constancia de Estudios (Simple)')
            case "/reportes/list_usuarios": return('Listado de Usuarios')
            case "/reportes/carta_egreso": return('Carta de Egreso')
            case "/reportes/carga_horaria": return('Carga Horaria')
            case "/reportes/pensum_programas": return('Certificación Plan de Estudios (Pensum)')
            case "/reportes/mod_estudios_simple": return('Constancia de Modalidad de Estudio (Simple)')
            case "/reportes/mod_estudios_cert": return('Constancia de Modalidad de Estudio (Certificada)')
            case "/reportes/culminacion_est_dir": return('Constancia de Culminación de Estudios (Simple)')
            case "/reportes/culminacion_est_cert_dir": return('Constancia de Culminación de Estudios (Certificada)')
            case "/reportes/constancia_conducta_cert_dir": return('Constancia de Buena Conducta (Certificada)')
            case "/reportes/est_retirados": return('Estudiantes Retirados')
            default: return('Asistencia')
        }
    }

    valorSelectReporte = (valorReporte) => {
        this.setState({
            valorReporte
        },() => {
            this.props.history.push(`/reportes/${this.state.valorReporte.value}`);
        });
    }

    contenido = () => {
        return (
            <Switch>
                <Route path="/reportes/asistencia" component={ () => <RepAsistencia/> } />
                <Route path="/reportes/list_estudiantes" component={ () => <EstudiantesList/> } />
                <Route path="/reportes/notas_certificadas" component={ () => <RepNotasCert/> } />
                <Route path="/reportes/constancia_estudios" component={ () => <RepConstancia/> } />
                <Route path="/reportes/list_usuarios" component={ () => <ListUsuarios/> } />
                <Route path="/reportes/carta_egreso" component={ () => <RepSolicitudes tipo = "Carta de Egreso"/> } />
                <Route path="/reportes/carga_horaria" component={ () => <RepSolicitudes tipo = "Carga Horaria"/> } />
                <Route path="/reportes/pensum_programas" component={ () => <RepSolicitudes tipo = "Certificación Plan de Estudios (Pensum)"/> } />
                <Route path="/reportes/mod_estudios_simple" component={ () => <RepSolicitudes tipo = "Constancia de Modalidad de Estudio (Simple)"/> } />
                <Route path="/reportes/mod_estudios_cert" component={ () => <RepSolicitudes tipo = "Constancia de Modalidad de Estudio (Certificada)"/> } />
                <Route path="/reportes/culminacion_est_dir" component={ () => <RepSolicitudes tipo = "Constancia de Culminación de Estudios (Simple)"/> } />
                <Route path="/reportes/culminacion_est_cert_dir" component={ () => <RepSolicitudes tipo = "Constancia de Culminación de Estudios (Certificada)"/> } />
                <Route path="/reportes/constancia_conducta_cert_dir" component={ () => <RepSolicitudes tipo = "Constancia de Buena Conducta (Certificada)"/> } />
                <Route path="/reportes/est_retirados" component={ () => <RepEstRetirados/> } />
                <Redirect to = "/reportes/asistencia" />
            </Switch>
        )
    }

    render() {
        const customStyles = {
            menu:(provided) => ({
                ...provided,
                zIndex: 15
              }),
        }

        const Reportes = [
            { value: 'asistencia', label: 'Listado de Asistencia' },
            { value: 'list_estudiantes', label: 'Listado de Estudiantes' },
            { value: 'notas_certificadas', label: 'Notas Certificadas' },
            { value: 'list_usuarios', label: 'Listado de Usuarios' },
            { value: 'constancia_estudios', label: 'Constancia de Estudios (Simple)' },
            { value: 'carta_egreso', label: 'Carta de Egreso' },
            { value: 'carga_horaria', label: 'Carga Horaria' },
            { value: 'pensum_programas', label: 'Certificación Plan de Estudios (Pensum)' },
            { value: 'mod_estudios_simple', label: 'Constancia de Modalidad de Estudio (Simple)' },
            { value: 'mod_estudios_cert', label: 'Constancia de Modalidad de Estudio (Certificada)' },
            { value: 'culminacion_est_dir', label: 'Constancia de Culminación de Estudios (Simple)' },
            { value: 'culminacion_est_cert_dir', label: 'Constancia de Culminación de Estudios (Certificada)' },
            { value: 'constancia_conducta_cert_dir', label: 'Constancia de Buena Conducta (Certificada)' },
            { value: 'est_retirados', label: 'Estudiantes Retirados' },
        ];

        let sortJSON = (data, key, orden) => {
            return data.sort(function (a, b) {
                let x = a[key],
                y = b[key];
        
                if (orden === 'asc')  return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                if (orden === 'desc') return ((x > y) ? -1 : ((x < y) ? 1 : 0));
            });
        }

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:5}}>
                        <Row>
                            <Col md={7}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona el tipo de Reporte
                                </div>
                            </Col>
                            <Col md={5}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorSelectReporte}
                                    options={sortJSON(Reportes, 'label', 'asc')}
                                    styles={customStyles}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`Opciones de ${this.valorReporteLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
 
export default MainReportes;


// WEBPACK FOOTER //
// ./src/views/Reportes/MainReportes.jsx